import { FormData } from '@/api/types';
import { API_URL } from '@/consts';

import {
  keepPreviousData,
  UndefinedInitialDataOptions,
  useQuery,
} from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

export const FORM_DATA_KEY_FACTORY = (id?: string) => ['form', id];

export const fetchFormData = async (id: string): Promise<FormData> => {
  const data = await fetch(`${API_URL}/api/case-card/${id}`, {
    headers: {
      accept: 'application/json',
    },
  });

  return data.json();
};

export const formDataQueryOptions = (id: string | undefined) =>
  ({
    queryKey: FORM_DATA_KEY_FACTORY(id),
    queryFn: ({ queryKey }) => fetchFormData(queryKey[1] as string),
    retry: false,
    staleTime: Infinity,
    enabled: !!id,
    throwOnError: true,
    placeholderData: keepPreviousData,
  }) as UndefinedInitialDataOptions<
    FormData,
    Error,
    FormData,
    (string | undefined)[]
  >;
export const useFormDataQuery = () => {
  const { id } = useParams();

  return useQuery(formDataQueryOptions(id));
};
